webpackJsonp([1],{

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(171);


/** @jsx h */

var container = document.querySelector('.js-quiz-app');
if (container !== null) {
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__components_App__["a" /* App */], QuizSettings), container);
}

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_reducers_Root_reducer__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Previous__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Next__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Wizard__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questions_json__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__questions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__questions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__results_json__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__results_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__results_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__adapters_quiz_adapter__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__adapters_results_adapter__ = __webpack_require__(187);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












/** @jsx h */

var App = function App(_ref) {
  var title = _ref.title,
      description = _ref.description,
      questions = _ref.questions,
      answers = _ref.answers,
      results = _ref.results,
      resulted_title = _ref.resulted_title,
      resulted_description = _ref.resulted_description;

  var firstQuestion = '' + questions[0].question + questions[0].position;
  var initialState = {
    wizard: {
      title: title,
      description: description,
      resulted_title: resulted_title,
      resulted_description: resulted_description,
      current: firstQuestion,
      previous: '',
      next: '',
      history: _defineProperty({}, firstQuestion, firstQuestion)
    },
    quiz: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__adapters_quiz_adapter__["a" /* QuizAdapter */])(questions, answers, results)),
    results: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__adapters_results_adapter__["a" /* ResultsAdapter */])(results))
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__["a" /* StateProvider */],
    { initialState: initialState, reducer: __WEBPACK_IMPORTED_MODULE_2__state_reducers_Root_reducer__["a" /* reducers */] },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'u-flex c-quiz__container' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Wizard__["a" /* Wizard */], null)
    )
  );
};

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Quiz_reducer__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wizard_reducer__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Results_reducer__ = __webpack_require__(179);





var reducers = function reducers(_ref, action) {
  var quiz = _ref.quiz,
      wizard = _ref.wizard,
      results = _ref.results;

  console.info('Action', action);
  console.info('State', { quiz: quiz, wizard: wizard, results: results });
  return {
    wizard: Object(__WEBPACK_IMPORTED_MODULE_2__Wizard_reducer__["a" /* wizardReducer */])(wizard, action),
    quiz: Object(__WEBPACK_IMPORTED_MODULE_1__Quiz_reducer__["a" /* quizReducer */])(quiz, action),
    results: Object(__WEBPACK_IMPORTED_MODULE_3__Results_reducer__["a" /* resultsReducer */])(results, action)
  };
};

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* unused harmony export applyMiddleware */
/* unused harmony export bindActionCreators */
/* unused harmony export combineReducers */
/* unused harmony export compose */
/* unused harmony export createStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(174);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */

  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */

  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */

  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */

  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */

  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */

function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */

function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(176);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7), __webpack_require__(175)(module)))

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

module.exports = function (originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return quizReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Quiz_actions__ = __webpack_require__(59);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var quizReducer = function quizReducer(state, action) {
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_Quiz_actions__["a" /* QUIZ_ANSWER */]:
      return _extends({}, state, _defineProperty({}, action.payload.question, _extends({}, state[action.payload.question], {
        answers: _extends({}, state[action.payload.question].answers, Object.keys(state[action.payload.question].answers).reduce(function (_, a) {
          return _extends({}, _, _defineProperty({}, a, _extends({}, state[action.payload.question].answers[a], {
            selected: false
          })));
        }, state[action.payload.question].answers), _defineProperty({}, action.payload.answer, _extends({}, state[action.payload.question].answers[action.payload.answer], {
          selected: true
        })))
      })));
    default:
      return state;
  }
};

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wizardReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Wizard_actions__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var wizardReducer = function wizardReducer(state, action) {
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_Wizard_actions__["a" /* WIZARD_ANSWER */]:
      return _extends({}, state, {
        previous: state.current,
        current: action.payload,
        history: _extends({}, state.history, _defineProperty({}, action.payload, action.payload))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_Wizard_actions__["c" /* WIZARD_PREVIOUS */]:
      return _extends({}, state, {
        previous: action.payload,
        current: state.previous,
        next: state.current
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_Wizard_actions__["b" /* WIZARD_NEXT */]:
      return _extends({}, state, {
        previous: state.current,
        current: state.next,
        next: action.payload
      });
    default:
      return state;
  }
};

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resultsReducer; });
var resultsReducer = function resultsReducer(state, action) {
  switch (action.type) {
    default:
      return state;
  }
};

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wizard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Next__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Previous__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_actions_Wizard_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WizardResult__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WizardAnswer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WizardMeta__ = __webpack_require__(183);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


/** @jsx h */








var Wizard = function Wizard() {
  var _useAppState = Object(__WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__["b" /* useAppState */])(),
      _useAppState2 = _slicedToArray(_useAppState, 2),
      _useAppState2$ = _useAppState2[0],
      wizard = _useAppState2$.wizard,
      quiz = _useAppState2$.quiz,
      results = _useAppState2$.results,
      dispatch = _useAppState2[1];

  var question = quiz[wizard.current];
  var previousQuestion = quiz[wizard.previous];
  var nextQuestion = quiz[wizard.next];
  var result = !question && results.items[wizard.current] !== undefined ? results.items[wizard.current] : undefined;
  var nextResult = question && results.items[wizard.next] !== undefined ? results.items[wizard.next] : undefined;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('c-quiz__wrapper', {
        'c-quiz__questioning': question !== undefined,
        'c-quiz__resulted': result !== undefined
      })
    },
    previousQuestion === undefined && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__WizardMeta__["a" /* WizardMeta */], { title: wizard.title, description: wizard.description }),
    result !== undefined && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_8__WizardMeta__["a" /* WizardMeta */], { title: results.title, description: results.description }),
    question && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'h1',
      { 'class': 'c-quiz__question-title u-squeeze--m' },
      question.title
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'c-quiz__wizard' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'c-quiz__previous c-quiz__previous--desktop' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Previous__["a" /* Previous */], { disabled: previousQuestion === undefined })
      ),
      question && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__WizardAnswer__["a" /* WizardAnswer */], null),
      result && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__WizardResult__["a" /* WizardResult */], null),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'c-quiz__next  c-quiz__next--desktop' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__Next__["a" /* Next */], {
          disabled: result === undefined && nextQuestion === undefined && nextResult === undefined
        })
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'c-quiz__bottom-bar' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'c-quiz__previous c-quiz__previous--mobile' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Previous__["a" /* Previous */], { disabled: previousQuestion === undefined })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'c-quiz__next  c-quiz__next--mobile' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__Next__["a" /* Next */], {
          disabled: result === undefined && nextQuestion === undefined && nextResult === undefined
        })
      )
    )
  );
};

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_Quiz_context__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



/** @jsx h */


var WizardResult = function WizardResult() {
  var _useAppState = Object(__WEBPACK_IMPORTED_MODULE_2__state_Quiz_context__["b" /* useAppState */])(),
      _useAppState2 = _slicedToArray(_useAppState, 2),
      _useAppState2$ = _useAppState2[0],
      wizard = _useAppState2$.wizard,
      quiz = _useAppState2$.quiz,
      results = _useAppState2$.results,
      dispatch = _useAppState2[1];

  var result = results.items[wizard.current];

  var jsonAnswers = [];
  Object.entries(quiz).map(function (question) {
    console.log();
    var quizTitle = question[0];
    var answers = question[1];

    Object.entries(answers).map(function (answer) {
      Object.entries(answer[1]).map(function (option) {
        if (option[1].selected) {
          jsonAnswers.push({ vraag: quizTitle, antwoord: option[0] });
        }
      });
    });
  });

  if (result.url) {
    location.href = result.url + ('?answers=' + JSON.stringify(jsonAnswers));
  }

  console.log(quiz);

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'c-quiz__results' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'c-quiz__result-body' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        className: 'u-squeeze--xs',
        dangerouslySetInnerHTML: { __html: result.content }
      })
    )
  );
};

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardAnswer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_actions_Wizard_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_Quiz_context__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_actions_Quiz_actions__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


/** @jsx h */




var WizardAnswer = function WizardAnswer() {
  var _useAppState = Object(__WEBPACK_IMPORTED_MODULE_2__state_Quiz_context__["b" /* useAppState */])(),
      _useAppState2 = _slicedToArray(_useAppState, 2),
      _useAppState2$ = _useAppState2[0],
      wizard = _useAppState2$.wizard,
      quiz = _useAppState2$.quiz,
      dispatch = _useAppState2[1];

  var question = quiz[wizard.current];
  var answers = Object.keys(question.answers).map(function (a) {
    return _extends({}, question.answers[a], {
      key: a
    });
  });

  var onClick = function onClick(answer) {
    return function () {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__state_actions_Quiz_actions__["a" /* QUIZ_ANSWER */],
        payload: {
          question: wizard.current,
          answer: answer.key
        }
      });
      if (answer.next) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__state_actions_Wizard_actions__["a" /* WIZARD_ANSWER */], payload: answer.next });
      } else {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__state_actions_Wizard_actions__["a" /* WIZARD_ANSWER */], payload: answer.result });
      }
    };
  };
  var longAnswers = answers.filter(function (a) {
    return a.title.split(' ').length > 1;
  }).length > 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: 'c-quiz__question' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('c-quiz__answers', {
          'c-quiz__answers--column': longAnswers
        })
      },
      answers.map(function (a) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          {
            key: wizard.current + '-' + a.key,
            className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('c-quiz__answer', {
              'c-quiz__answer--selected': a.selected,
              'c-quiz__answer--flex': longAnswers
            }),
            onClick: onClick(a)
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: 'u-image c-quiz__answer-image' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
              className: 'u-image__background',
              src: a.image,
              alt: a.title
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'button',
            { 'class': 'c-quiz__answer-btn' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'svg',
              {
                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('c-icon', 'c-quiz__answer-check', {
                  'c-quiz__answer-check--selected': a.selected
                })
              },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('use', { href: '#quiz-check', xlinkHref: '#quiz-check' })
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'span',
              { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('c-quiz__answer-title') },
              a.title,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'svg',
                { className: 'c-icon c-quiz__answer-next' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('use', {
                  href: '#quiz-arrow-right',
                  xlinkHref: '#quiz-arrow-right'
                })
              )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', null)
          )
        );
      })
    )
  );
};

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WizardMeta; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

/** @jsx h */

var WizardMeta = function WizardMeta(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    "div",
    { className: "c-quiz__meta u-squeeze--m" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "h1",
      { className: "c-quiz__title" },
      title
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "p",
      { className: "c-quiz__description" },
      description
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "svg",
      { className: "c-icon c-quiz__squiggle" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("use", { href: "#squiggle", xlinkHref: "#squiggle" })
    )
  );
};

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

module.exports = {"question-1a":{"title":"Voel je je veilig in je eigen badkamer?","answers":{"yes":{"title":"Ja","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-1b"},"no":{"title":"Nee","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-1b"}}},"question-1b":{"title":"Ben je wel eens uitgegleden of bang geweest om te vallen in je huidige badkamer?","answers":{"yes":{"title":"Ja","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-1c"},"no":{"title":"Nee","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-1c"}}},"question-1c":{"title":"Hoe douche in je huidige badkamer?","answers":{"a":{"title":"In bad","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-5a"},"b":{"title":"In een douche met hoge instap","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-2a"},"c":{"title":"In een inloopdouche","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-2a"}}},"question-2a":{"title":"Ben je tevreden over je huidige situatie van douchen?","answers":{"yes":{"title":"Ja","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-4a"},"no":{"title":"Nee","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-3a"}}},"question-3a":{"title":"Ben je tevreden over de andere onderdelen van je badkamer?","answers":{"yes":{"title":"Ja","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","final":true,"next":"result-2"},"no":{"title":"Nee","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","final":true,"next":"result-3"}}},"question-4a":{"title":"Ben je tevreden over de andere onderdelen van je badkamer?","answers":{"yes":{"title":"Ja","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","final":true,"next":"result-4"},"no":{"title":"Nee","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","final":true,"next":"result-5"}}},"question-5a":{"title":"Wil je graag het huidige bad behouden als je veilig kan instappen?","answers":{"yes":{"title":"Ja","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","final":true,"next":"result-1"},"no":{"title":"Nee","image":"https://images.unsplash.com/photo-1513149322119-bd83e691f24c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80","next":"question-3a"}}}}

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

module.exports = {"result-1":{"title":"Uitslag = deur in bad","body":""},"result-2":{"title":"Uitslag = inloopdouche"},"result-3":{"title":"Uitslag = inloopdouche of renovatie"},"result-4":{"title":"Uitslag = alles perfect, blijf genieten"},"result-5":{"title":"Uitslag = Badkamerrenovatie"}}

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuizAdapter; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var QuizAdapter = function QuizAdapter(questions, answers, results) {
  var resultset = {};
  questions.map(function (q) {
    var key = "" + q.question + q.position;
    resultset[key] = { title: q.question };
    answers.filter(function (a) {
      return a.parent === q.question;
    }).map(function (a) {
      resultset[key] = _extends({}, resultset[key], {
        answers: _extends({}, resultset[key].answers, _defineProperty({}, "" + a.answer + a.position, {
          title: a.answer,
          image: a.image.full,
          result: results.items.filter(function (n) {
            return n.title === a.nextresult;
          }).map(function (n) {
            return "" + n.title;
          })[0],
          next: questions.filter(function (n) {
            return n.question === a.nextquestion;
          }).map(function (n) {
            return "" + n.question + n.position;
          })[0]
        }))
      });
    });
  });
  console.log(resultset);

  return resultset;
};

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultsAdapter; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ResultsAdapter = function ResultsAdapter(results) {
  var resultset = {};
  results.items.map(function (r) {
    var key = "" + r.title;
    resultset[key] = r;
  });
  console.log(resultset);

  return _extends({}, results, {
    items: _extends({}, resultset)
  });
};

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return m; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return p; });
/* unused harmony export useLayoutEffect */
/* unused harmony export useRef */
/* unused harmony export useImperativeHandle */
/* unused harmony export useMemo */
/* unused harmony export useCallback */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return w; });
/* unused harmony export useDebugValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var t,
    u,
    r,
    i = [],
    o = __WEBPACK_IMPORTED_MODULE_0_preact__["options"].__r,
    f = __WEBPACK_IMPORTED_MODULE_0_preact__["options"].diffed,
    c = __WEBPACK_IMPORTED_MODULE_0_preact__["options"].__c,
    e = __WEBPACK_IMPORTED_MODULE_0_preact__["options"].unmount;function a(t) {
  __WEBPACK_IMPORTED_MODULE_0_preact__["options"].__h && __WEBPACK_IMPORTED_MODULE_0_preact__["options"].__h(u);var r = u.__H || (u.__H = { t: [], u: [] });return t >= r.t.length && r.t.push({}), r.t[t];
}function v(n) {
  return m(x, n);
}function m(n, r, i) {
  var o = a(t++);return o.__c || (o.__c = u, o.i = [i ? i(r) : x(void 0, r), function (t) {
    var u = n(o.i[0], t);o.i[0] !== u && (o.i[0] = u, o.__c.setState({}));
  }]), o.i;
}function p(n, r) {
  var i = a(t++);q(i.o, r) && (i.i = n, i.o = r, u.__H.u.push(i));
}function l(n, r) {
  var i = a(t++);q(i.o, r) && (i.i = n, i.o = r, u.__h.push(i));
}function d(n) {
  return y(function () {
    return { current: n };
  }, []);
}function s(n, t, u) {
  l(function () {
    "function" == typeof n ? n(t()) : n && (n.current = t());
  }, null == u ? u : u.concat(n));
}function y(n, u) {
  var r = a(t++);return q(r.o, u) ? (r.o = u, r.v = n, r.i = n()) : r.i;
}function T(n, t) {
  return y(function () {
    return n;
  }, t);
}function w(n) {
  var r = u.context[n.__c];if (!r) return n.__;var i = a(t++);return null == i.i && (i.i = !0, r.sub(u)), r.props.value;
}function A(t, u) {
  __WEBPACK_IMPORTED_MODULE_0_preact__["options"].useDebugValue && __WEBPACK_IMPORTED_MODULE_0_preact__["options"].useDebugValue(u ? u(t) : t);
}function F() {
  i.some(function (n) {
    n.__P && (n.__H.u.forEach(_), n.__H.u.forEach(g), n.__H.u = []);
  }), i = [];
}function _(n) {
  n.m && n.m();
}function g(n) {
  var t = n.i();"function" == typeof t && (n.m = t);
}function q(n, t) {
  return !n || t.some(function (t, u) {
    return t !== n[u];
  });
}function x(n, t) {
  return "function" == typeof t ? t(n) : t;
}__WEBPACK_IMPORTED_MODULE_0_preact__["options"].__r = function (n) {
  o && o(n), t = 0, (u = n.__c).__H && (u.__H.u.forEach(_), u.__H.u.forEach(g), u.__H.u = []);
}, __WEBPACK_IMPORTED_MODULE_0_preact__["options"].diffed = function (t) {
  f && f(t);var u = t.__c;if (u) {
    var o = u.__H;o && o.u.length && (1 !== i.push(u) && r === __WEBPACK_IMPORTED_MODULE_0_preact__["options"].requestAnimationFrame || ((r = __WEBPACK_IMPORTED_MODULE_0_preact__["options"].requestAnimationFrame) || function (n) {
      var t,
          u = function u() {
        clearTimeout(r), cancelAnimationFrame(t), setTimeout(n);
      },
          r = setTimeout(u, 100);"undefined" != typeof window && (t = requestAnimationFrame(u));
    })(F));
  }
}, __WEBPACK_IMPORTED_MODULE_0_preact__["options"].__c = function (n, t) {
  t.some(function (n) {
    n.__h.forEach(_), n.__h = n.__h.filter(function (n) {
      return !n.i || g(n);
    });
  }), c && c(n, t);
}, __WEBPACK_IMPORTED_MODULE_0_preact__["options"].unmount = function (n) {
  e && e(n);var t = n.__c;if (t) {
    var u = t.__H;u && u.t.forEach(function (n) {
      return n.m && n.m();
    });
  }
};
//# sourceMappingURL=hooks.module.js.map

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QUIZ_ANSWER; });
var QUIZ_ANSWER = '[QUIZ] Answer';

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StateContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StateProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useAppState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_hooks__ = __webpack_require__(34);



/** @jsx h */
var StateContext = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["createContext"])();
var StateProvider = function StateProvider(_ref) {
  var reducer = _ref.reducer,
      initialState = _ref.initialState,
      children = _ref.children;
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    StateContext.Provider,
    { value: Object(__WEBPACK_IMPORTED_MODULE_1_preact_hooks__["c" /* useReducer */])(reducer, initialState) },
    children
  );
};
var useAppState = function useAppState() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_preact_hooks__["a" /* useContext */])(StateContext);
};

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Previous; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_Wizard_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_hooks__ = __webpack_require__(34);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





/** @jsx h */

var Previous = function Previous(_ref) {
  var disabled = _ref.disabled;

  var _useAppState = Object(__WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__["b" /* useAppState */])(),
      _useAppState2 = _slicedToArray(_useAppState, 2),
      wizard = _useAppState2[0].wizard,
      dispatch = _useAppState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_3_preact_hooks__["b" /* useEffect */])(function () {
    return {
      disabled: disabled
    };
  }, [disabled]);

  var onClick = function onClick() {
    var index = Object.keys(wizard.history).findIndex(function (v, i) {
      return v === wizard.previous;
    });
    var previous = Object.keys(wizard.history)[index - 1];
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__state_actions_Wizard_actions__["c" /* WIZARD_PREVIOUS */], payload: previous });
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'button',
    {
      className: 'c-quiz__previous-btn',
      onClick: onClick,
      disabled: disabled
    },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'svg',
      { className: 'c-icon c-quiz__arrow-icon' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('use', { href: '#quiz-arrow-left', xlinkHref: '#quiz-arrow-left' })
    ),
    QuizSettings.localization.previous
  );
};

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Next; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_Wizard_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preact_hooks__ = __webpack_require__(34);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





/** @jsx h */

var Next = function Next(_ref) {
  var disabled = _ref.disabled;

  var _useAppState = Object(__WEBPACK_IMPORTED_MODULE_1__state_Quiz_context__["b" /* useAppState */])(),
      _useAppState2 = _slicedToArray(_useAppState, 2),
      wizard = _useAppState2[0].wizard,
      dispatch = _useAppState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_3_preact_hooks__["b" /* useEffect */])(function () {
    return {
      disabled: disabled
    };
  }, [disabled]);

  var onClick = function onClick() {
    var index = Object.keys(wizard.history).findIndex(function (v, i) {
      return v === wizard.next;
    });
    var next = Object.keys(wizard.history)[index + 1];
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__state_actions_Wizard_actions__["b" /* WIZARD_NEXT */], payload: next });
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'button',
    { className: 'c-quiz__next-btn', onClick: onClick, disabled: disabled },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      null,
      QuizSettings.localization.next
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'svg',
      { className: 'c-icon c-quiz__arrow-icon' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('use', { href: '#quiz-arrow-right', xlinkHref: '#quiz-arrow-right' })
    )
  );
};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(63)) === 'object' && __webpack_require__(63)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WIZARD_PREVIOUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WIZARD_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WIZARD_ANSWER; });
var WIZARD_PREVIOUS = '[Wizard] Previous';
var WIZARD_NEXT = '[Wizard] Next';
var WIZARD_ANSWER = '[Wizard] Answer';

/***/ })

},[170]);


// WEBPACK FOOTER //
// quiz.09d8cf589a7ef3c6813a.js